module.exports = __webpack_public_path__ + "static/beauty-box-mobile-03911f8bef25b6426faa943444dbb0c6.jpg";